<template>
  <footer class="bg-dark-900 text-white">
    <div class="container-width px-4 md:px-8 lg:px-16 py-12">
      <div class="grid md:grid-cols-3 gap-8">
        <!-- Über -->
        <div>
          <h3 class="text-lg font-bold mb-4">Enrico Reinsdorf</h3>
          <p class="text-gray-400">
            Senior UX Designer mit nutzerzentriertem Ansatz
          </p>
        </div>

        <!-- Navigation -->
        <div>
          <h3 class="text-lg font-bold mb-4">Navigation</h3>
          <ul class="space-y-2">
            <li v-for="item in navigation" :key="item.to">
              <NuxtLink
                :to="item.to"
                class="text-gray-400 hover:text-white transition-colors"
              >
                {{ item.label }}
              </NuxtLink>
            </li>
          </ul>
        </div>

        <!-- Kontakt -->
        <div>
          <h3 class="text-lg font-bold mb-4">Kontakt</h3>
          <ul class="space-y-2 text-gray-400">
            <li>
              <a href="mailto:enrico.reinsdorf@re-design.de" class="hover:text-white transition-colors">
                enrico.reinsdorf@re-design.de
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/enrico-reinsdorf-6b091125/"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:text-white transition-colors"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p class="text-gray-400 text-sm">
          © {{ currentYear }} Enrico Reinsdorf. Alle Rechte vorbehalten.
        </p>
        <div class="flex gap-6 text-sm">
          <NuxtLink to="/impressum" class="text-gray-400 hover:text-white transition-colors">
            Impressum
          </NuxtLink>
          <NuxtLink to="/datenschutz" class="text-gray-400 hover:text-white transition-colors">
            Datenschutz
          </NuxtLink>
          <button
            @click="openSettings"
            class="text-gray-400 hover:text-white transition-colors"
          >
            Cookie-Einstellungen
          </button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear()
const { openSettings } = useCookieConsent()

const navigation = [
  { label: 'Home', to: '/' },
  { label: 'Expertise', to: '/expertise' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'Artikel', to: '/articles' },
  { label: 'Werdegang', to: '/career' },
  { label: 'Kontakt', to: '/contact' }
]
</script>
